import { render, staticRenderFns } from "./ReviewMembersSetting.vue?vue&type=template&id=6378ad64&scoped=true&"
import script from "./ReviewMembersSetting.vue?vue&type=script&lang=js&"
export * from "./ReviewMembersSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMembersSetting.vue?vue&type=style&index=0&id=6378ad64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378ad64",
  null
  
)

export default component.exports